module.exports = __webpack_public_path__ + "media/images/icons/v2/menu-01-f4ba27749db69d7bfa38e66ef7dfdc57.svg";